interface BrowserShieldProps {
  className?: string;
  color?: string;
}

export default function BrowserShield({ className = '', color = '#10B981' }: BrowserShieldProps) {
  return (
    <svg
      width='40'
      height='40'
      viewBox='0 0 40 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M20 3L7 8.5V18.5C7 27.25 13.05 35.35 20 37C26.95 35.35 33 27.25 33 18.5V8.5L20 3Z'
        fill={color}
        fillOpacity='0.15'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M14 18L18 22L26 14' stroke={color} strokeWidth='2.5' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
}
